import { render } from "./AdmCollectInfo.vue?vue&type=template&id=183c217e&scoped=true"
import script from "./AdmCollectInfo.vue?vue&type=script&lang=js"
export * from "./AdmCollectInfo.vue?vue&type=script&lang=js"

import "./AdmCollectInfo.vue?vue&type=style&index=0&id=183c217e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183c217e"]])

export default __exports__